import React from 'react'
import {
  Box,
  Icon,
  Body2,
  Button,
  AlignItems,
  JustifyContent,
  Color,
  FontWeight,
  TextAlign,
  Display,
  FlexDirection,
  Heading4,
  IconVariant,
  Body1,
  withCitrusTheme,
  Theme,
  Strong,
  Space,
} from '@gousto-internal/citrus-react'
import { parseMessageContent } from '../utils/templateUtils'
import { BannerConfig } from '../types'

export interface HomepageNDDBannerProps {
  config?: BannerConfig | null
  onCtaClick?: () => void
  theme?: Theme
}

const BoxWithGradientStyle = withCitrusTheme(Box, (theme) => ({
  background: `linear-gradient(90deg, ${theme.color(Color.Success_800)} 0%, ${theme.color(
    Color.Success_900,
  )} 100%)`,
}))

const HomepageNDDBannerComponent: React.FC<HomepageNDDBannerProps> = ({ config, onCtaClick }) => {
  const { title, subtitle, footer, ctaText } = config || {}

  if (!config || !title) {
    return null
  }

  return (
    <Box
      display="flex"
      flexDirection={FlexDirection.Column}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      paddingV={6}
      paddingH={4}
      bg={Color.ColdGrey_50}
      gap={4}
    >
      <BoxWithGradientStyle
        display="flex"
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        borderRadius="round"
        width="40"
        height="40"
        paddingV={2}
        paddingH={2}
        color={Color.Success_50}
      >
        <Icon name="local_shipping" size={5} variant={IconVariant.Inherit} />
      </BoxWithGradientStyle>
      <Box
        display="flex"
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.Center}
        gap={1}
      >
        <Heading4
          color={Color.ColdGrey_800}
          fontWeight={FontWeight.SemiBold}
          textAlign={TextAlign.Center}
        >
          {title}
        </Heading4>

        {subtitle && (
          <Body2 color={Color.ColdGrey_700} textAlign={TextAlign.Center}>
            {parseMessageContent(subtitle, {
              strong: (content, index) => (
                <Strong fontWeight={FontWeight.SemiBold} key={index}>
                  {content}
                </Strong>
              ),
            })}
          </Body2>
        )}

        {footer && (
          <>
            <Space size={2} />
            <Body1
              color={Color.Success_800}
              fontWeight={FontWeight.SemiBold}
              textAlign={TextAlign.Center}
              size={4}
            >
              {footer}
            </Body1>
          </>
        )}

        {ctaText && (
          <>
            <Space size={2} />
            <Box display={[Display.None, Display.Block]}>
              <Button
                width={['min(380px, 92%)', '343px']}
                height="48px"
                onClick={onCtaClick}
                data-testid="homepage-ndd-cta"
              >
                {ctaText}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Box>
  )
}

export const HomepageNDDBanner = HomepageNDDBannerComponent
